import Cookies from 'js-cookie'

export const TOKEN_KEY = 'kzc-token'

// cookie保存的天数
export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: 7 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}
export const removeToken = () => {
  Cookies.remove(TOKEN_KEY)
}

// 将时间戳转化成时间表现 xxxx-xx-xx
export const timestampToMoment = (timestamp) => {
  const date = new Date(timestamp)
  // return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)} ${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}:${('0' + date.getSeconds()).slice(-2)}`;
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`
}

// 将时间戳转化成时间表现 xxxx-xx-xx xx:xx:xx
export const timestampToMomentTime = (timestamp) => {
  const date = new Date(timestamp)
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)} ${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}:${('0' + date.getSeconds()).slice(-2)}`
  // return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`
}

// 将对象里的属性转化成自定义排序的数组
// const order = ['did', 'swept_mileage', 'cleaned_rows', 'cleaned_segments', 'clean_time','clean_speed','crossed_panel_number']
export const objToArray = (obj, order) => {
  const sortedObj = Object.keys(obj)
    .sort((a, b) => order.indexOf(a) - order.indexOf(b))
    .reduce((sortedObj, key) => {
      sortedObj[key] = obj[key]
      return sortedObj
    }, {})
  return Object.values(sortedObj)
}

// 判断两个对象以及里面的值是否相等
export const isEqual = (obj1, obj2) => {
  // 如果两个对象是同一个引用，直接返回 true
  if (obj1 === obj2) return true
  // 如果其中一个为 null 或者不是对象，返回 false
  if (obj1 === null || typeof obj1 !== 'object' || obj2 === null || typeof obj2 !== 'object') {
    return false
  }
  // 获取两个对象的键
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)
  // 如果键的数量不一致，返回 false
  if (keys1.length !== keys2.length) return false
  // 遍历对象的键，递归比较每个键对应的值
  for (const key of keys1) {
    if (!keys2.includes(key) || !isEqual(obj1[key], obj2[key])) {
      return false
    }
  }
  // 如果所有键和值都相等，返回 true
  return true
}

const roleObj = {
  角色编辑: '1000',
  产品管理查看: '10001',
  产品管理操作: '10002',
  场地管理查看: '10003',
  场地管理操作: '10004',
  公司管理查看: '10005',
  公司管理编辑: '10006',
  权限管理查看: '10007',
  权限管理编辑: '10008',
  账号管理查看: '10009',
  账号管理编辑: '10010',
  清洁设备操作: '10011',
  铺装设备操作: '10012',
  产品1设备操作: '10013',
  产品2设备操作: '10014',
  设备新增: '1013',
  设备摄像头: '1014',
  设备详情: '1015',
  设备分享: '1016',
  设备终端: '1017',
  设备编辑: '1018',
  参数设置: '1019',
  版本管理: '1020'
}
export const checkEditDeleteRole = (btnModel, type) => {
  const userInfo = JSON.parse(localStorage.getItem('kzcUserInfo'))
  // 管理员有全部权限
  if (userInfo.role === 3) return true

  // 检查是否有编辑删除权限
  const roleArr = userInfo.auth_page.split(',') || []
  // 如果没有权限，返回false
  if (roleArr.length === 0) return false
  btnModel = type === '1' ? '清洁设备操作' : type === '2' ? '铺装设备操作' : btnModel
  if (roleArr.includes(roleObj[btnModel])) {
    return true
  } else {
    return false
  }
}

// const validatePhoneNumber = (phoneNumber) => {
//   const regex = /^1[3-9]\d{9}$/;
//   return regex.test(phoneNumber);
// }
export const getRandomFloat = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * 优化后的任务区域组合函数
 * @param {Array} arrayData - 数据数组，如 ['A1/R1', 'A1/R2', 'A2/R3', ...]
 * @param {Array} arrayType - 类型数组，如 ['A1', 'A2', 'A3', 'A4']
 * @returns {Array} - 组合后的二维数组
 */

export const CombinationTaskArea = (arrayData, arrayType) => {
  // 获取任务区域组的最后一个值并提取数字
  const lastType = arrayType[arrayType.length - 1]
  const maxNum = parseInt(lastType[1]) // 假设格式为 'A1', 'A2' 等

  // 1. 创建基础数组，用null填充
  const baseArray = new Array(maxNum).fill(null)

  // 2. 填充任务区域组
  arrayType.forEach(item => {
    const typeNum = parseInt(item[1]) // 提取数字部分
    if (typeNum <= maxNum) {
      baseArray[typeNum - 1] = item
    }
  })

  // 3. 创建结果数组的副本
  const result = [...baseArray]

  // 4. 收集每个区域对应的数据项长度
  const dataLengths = []

  // 5. 处理每个非null的区域
  result.forEach((item, index) => {
    if (item) {
      // 找出所有包含该区域的数据
      const matchedData = arrayData.filter(data => data.includes(item))

      // 记录该区域的数据长度
      dataLengths.push(matchedData.length)

      // 替换为匹配的数据数组
      result[index] = matchedData.map(data => ({
        value: data,
        text: data
      }))
    }
  })

  // 6. 获取最大数据长度
  const maxDataLength = Math.max(...dataLengths, 0)

  // 7. 处理null区域，填充null数组
  for (let i = 0; i < result.length; i++) {
    if (result[i] === null) {
      result[i] = new Array(maxDataLength).fill(null)
    }
  }

  // 8. 处理每个区域的数据，按R值排序
  for (let i = 0; i < result.length; i++) {
    const currentArray = result[i]

    // 跳过已经是null数组的项
    if (currentArray[0] === null) continue

    // 创建按R值排序的数组
    const sortedArray = new Array(maxDataLength).fill(null)

    currentArray.forEach(item => {
      if (item && item.value) {
        const rNum = parseInt(item.value.split('/R')[1])
        if (rNum <= maxDataLength) {
          sortedArray[rNum - 1] = { value: item.value, text: item.value, checked: false }
        } else {
          sortedArray[maxDataLength] = { value: item.value, text: item.value, checked: false }
        }
      }
    })

    // 替换为排序后的数组
    result[i] = sortedArray
  }

  console.log('组合结果:', result)
  return result
}

export const processAllArrays = (inputArray) => {
  // 1. 提取所有唯一的前缀并排序
  const prefixes = [...new Set(inputArray.map(item => item.split('/')[0]))].sort()

  // 2. 找出最大R值
  const maxR = Math.max(...inputArray.map(item => parseInt(item.split('/R')[1])))

  // 3. 为每个前缀创建一行
  const result = prefixes.map(prefix => {
    // 创建当前行的数组，全部填充null
    const row = new Array(maxR).fill(null)

    // 找出所有属于当前前缀的元素
    const prefixItems = inputArray.filter(item => item.startsWith(prefix + '/'))

    // 放到正确的位置
    prefixItems.forEach(item => {
      const rNum = parseInt(item.split('/R')[1])
      row[rNum - 1] = item
    })

    return row
  })

  return result
}
